import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginSuccess = async (credentialResponse) => {
    if (!credentialResponse.credential) {
      console.error('No credential received');
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URI}/auth/google/employee`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({ credential: credentialResponse.credential }),
      });
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      console.log('Response:', data);
      localStorage.setItem('auth_token_crm', JSON.stringify({token: data.token, washerId: data.washerId}));
      window.location.href = '/';
    } catch (err) {
      console.error('Login error:', err);
      alert('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Login</Typography>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={() => {
              console.error('Login Failed');
              alert('Login Failed. Please try again.');
            }}
          />
        )}
      </Paper>
    </Box>
  );
};

export default Login;
